import React, { useState, useEffect } from "react";
import axios from "axios";

import DeletePost from "./Delete Post/DeletePost";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { GrAdd } from "react-icons/gr";
import { AiOutlineEdit } from "react-icons/ai";
import "./adminBlog.scss";

// Material
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

const columns = [
  { label: "Tite" },
  { label: "Date Created", align: "start" },
  { label: "Edit", align: "right" },
  { label: "Delete", align: "right" },
];

const rows = [
  { title: "hello world", date: "12/12/2021", edit: "edit", delete: "delete" },

  { title: "hello world", date: "12/12/2021", edit: "edit", delete: "delete" },
];

const Index = () => {

  const [state, setState] = useState([]);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const day = (createdAt) => {
    console.log(createdAt);
    let d = new Date(createdAt);
    let day = d.getDay();
    const data = `${d.getFullYear()}-${d.getMonth() + 1
      }-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    return data;
  };


  console.log(state);

  return (
    <>
      <div className="admin-blog">
        {/* <AdminSidebar /> */}

        <div className="right">
          <div className="create">
            <Link to="/admin/blog/create-post" className="create-icon">
              <GrAdd />
            </Link>
          </div>

          <div className="published">Published Post</div>

          <div className="published-table">
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column, index) => (
                        <TableCell
                          key={index}
                          align={column.align}
                        // style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {state
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {row.englishTitle}
                          </TableCell>
                          <TableCell style={{ width: 150 }} align={"start"}>
                            {day(row.createdAt)}
                          </TableCell>
                          <TableCell style={{ width: 100 }} align={"right"}>
                            <div
                              className="edit"
                            >
                              <AiOutlineEdit />
                            </div>
                          </TableCell>

                          <TableCell style={{ width: 100 }} align={"right"}>
                            <DeletePost originalUrl={row.originalUrl} />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
